import { Box, Typography } from '@mui/material';
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import heroBg from '../../../assets/imgs/hero.png';

import { useHeroStyles } from './hero.styles';

const Hero = () => {
  const classes = useHeroStyles();

  return (
    <Box
      className={classes.hero}
      sx={{
        backgroundImage: `url(${heroBg})`,
      }}
    >
      <Box className={classes.overlay} />

      <Box className={classes.text}>
        <Typography className={classes.welcome} vairant='p'>
          Welcome to Graphshala
        </Typography>
        <Typography variant='h1' className={classes.tagline}>
          Visual storytelling
          <br />
          at its finest!
        </Typography>
      </Box>
      <ImgComparisonSlider className={classes.imageSlider}>
        <img
          className='bg-img'
          slot='first'
          src='https://i.ibb.co/xq3yh0w/Untitled-1a.png'
          alt=''
        />
        <img
          slot='second'
          alt=''
          className='bg-img'
          src='https://i.ibb.co/L9Dzc1K/Untitled-1ab.png'
        />
        <svg
          slot='handle'
          xmlns='http://www.w3.org/2000/svg'
          width='100'
          viewBox='-8 -3 16 6'
        >
          <path
            stroke='#000'
            className='handles'
            d='M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2'
            stroke-width='1'
            fill='#000'
            vector-effect='non-scaling-stroke'
          ></path>
        </svg>
      </ImgComparisonSlider>
    </Box>
  );
};

export default Hero;
